import { render, staticRenderFns } from "./SectionItemRecipe.vue?vue&type=template&id=3fdcab6a&scoped=true&lang=pug&"
import script from "./SectionItemRecipe.vue?vue&type=script&lang=js&"
export * from "./SectionItemRecipe.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemRecipe.vue?vue&type=style&index=0&id=3fdcab6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdcab6a",
  null
  
)

export default component.exports